import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import * as endpoints from '../networkUtility/endpoints';
import * as localStorageActiontype from '../LocalStorage/ActionTypes';
import {getLocalStorage} from '../LocalStorage/GetLocalStorage';
import {toggleNotificationVisibility} from './networkNotification';
import {NotificationType} from '../Utility/InterFacesAndEnum';
import {toggleLoader} from './loader'
import {handle401Status} from '../Utility/Utility';

interface SettingsNode {
    settingId: number,
    settingFor: string,
    bronzeTicketPrice: number,
    silverTicketPrice: number,
    goldTicketPrice: number,
    platinumTicketPrice: number,
    bronzeSubTickets: number,
    silverSubTickets: number,
    goldSubTickets: number,
    platinumSubTickets: number,
    isAdminWinner: boolean,
    safetyDepositAmount: number
}

interface SettingsState {
    data: any
}


const settingsInitialState:SettingsState = {
    data: []
}

const settingsSlice = createSlice({
    name:'Settings detail slice',
    initialState: settingsInitialState,
    reducers:{
        setData: (state, action:PayloadAction<SettingsState>) => {
            return {
                ...state,
                data: action.payload.data
            }
        }
    }
});


export const getSettingsData = createAsyncThunk(
    'get settings data',
    async (payload:void, {dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch (endpoints.getSettingsData, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {

            if (response.statusCode === 401) {
                handle401Status();
            }

            if (response.statusCode === 200) {
                dispatch(setData({
                    data: response.result
                }))
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.success,
                    message: response.errorMsg
                }));
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: response.errorMsg
                }));
            }
        })
        .catch(() => {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: "Something went wrong"
            }));
        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        });
    }
);

export const updateSettingsData = createAsyncThunk(
    'Updated lottery or auction data',
    async(payload:SettingsNode | {}, {dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.updatedSettingsData, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            },
            body:JSON.stringify(payload)
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {

            if (response.statusCode === 401) {
                handle401Status();
            }

            if (response.statusCode === 200) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.success,
                    message: response.errorMsg
                }));
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: response.errorMsg
                }));
            }
        })
        .catch(() => {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: "Something went wrong"
            }));
        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        });
    });

    export const updateLotterySettingsData = createAsyncThunk(
        'Updated lottery  data',
        async(payload:SettingsNode | {}, {dispatch}) => {
            dispatch(toggleLoader({
                isLoading: true
            }));
            await fetch(endpoints.updatedLotterySettings, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                },
                body:JSON.stringify(payload)
            })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
    
                if (response.statusCode === 401) {
                    handle401Status();
                }
    
                if (response.statusCode === 200) {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.success,
                        message: response.errorMsg
                    }));
                } else {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: response.errorMsg
                    }));
                }
            })
            .catch(() => {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: "Something went wrong"
                }));
            })
            .finally(() => {
                dispatch(toggleLoader({
                    isLoading: false
                }));
            });
        });

        export const updateAuctionSettingsData = createAsyncThunk(
            'Updated  auction data',
            async(payload:SettingsNode | {}, {dispatch}) => {
                dispatch(toggleLoader({
                    isLoading: true
                }));
                await fetch(endpoints.updatedAuctionSettings, {
                    method: 'PUT',
                    headers: {
                        Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                        "Content-type": "application/json; charset=UTF-8",
                    },
                    body:JSON.stringify(payload)
                })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
        
                    if (response.statusCode === 401) {
                        handle401Status();
                    }
        
                    if (response.statusCode === 200) {
                        dispatch(toggleNotificationVisibility({
                            isVisible: true,
                            status: NotificationType.success,
                            message: response.errorMsg
                        }));
                    } else {
                        dispatch(toggleNotificationVisibility({
                            isVisible: true,
                            status: NotificationType.error,
                            message: response.errorMsg
                        }));
                    }
                })
                .catch(() => {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: "Something went wrong"
                    }));
                })
                .finally(() => {
                    dispatch(toggleLoader({
                        isLoading: false
                    }));
                });
            });

            export const updateSubscriptionSettingsData = createAsyncThunk(
                'Update subscription data',
                async(payload:SettingsNode | {}, {dispatch}) => {
                    dispatch(toggleLoader({
                        isLoading: true
                    }));
                    await fetch(endpoints.updatedSubscriptionSettings, {
                        method: 'PUT',
                        headers: {
                            Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                            "Content-type": "application/json; charset=UTF-8",
                        },
                        body:JSON.stringify(payload)
                    })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
            
                        if (response.statusCode === 401) {
                            handle401Status();
                        }
            
                        if (response.statusCode === 200) {
                            dispatch(toggleNotificationVisibility({
                                isVisible: true,
                                status: NotificationType.success,
                                message: response.errorMsg
                            }));
                        } else {
                            dispatch(toggleNotificationVisibility({
                                isVisible: true,
                                status: NotificationType.error,
                                message: response.errorMsg
                            }));
                        }
                    })
                    .catch(() => {
                        dispatch(toggleNotificationVisibility({
                            isVisible: true,
                            status: NotificationType.error,
                            message: "Something went wrong"
                        }));
                    })
                    .finally(() => {
                        dispatch(toggleLoader({
                            isLoading: false
                        }));
                    });
                });

export const {setData} = settingsSlice.actions;
export default settingsSlice.reducer